import React from 'react'
import { Stack, Typography } from '@mui/material'
import { useHideDirtyState } from '../../advanced-settings/providers'
import { DirtyMark } from '../../icons'

interface SectionSubHeadingProps {
  title: string
  righContent?: JSX.Element
  error?: boolean
  isDirty?: boolean
}

export const SectionSubHeading: React.FC<SectionSubHeadingProps> = ({ title, righContent, error, isDirty }) => {
  const hideDirtyState = useHideDirtyState()

  return (
    <Stack direction={'row'} alignItems={'center'}>
      <Typography
        py={1}
        fontWeight={'bold'}
        component="h3"
        sx={{
          color: error ? theme => theme.palette.error.main : theme => theme.palette.text.primary,
        }}
      >
        {title}
      </Typography>
      {isDirty && !hideDirtyState && <DirtyMark />}
      {righContent}
    </Stack>
  )
}
